import React, { useState, useMemo, useEffect } from "react";
import { storeContext } from "./store";

const StoreProvider = ({ children }) => {
  const [store, setStore] = useState({
    layout: "block",
    triggerAnimation: false,
    savedSlideIndex: 0,
  });

  useEffect(() => {}, [store]);

  const storeValue = useMemo(() => ({ store, setStore }), [store, setStore]);

  return (
    <storeContext.Provider value={storeValue}>{children}</storeContext.Provider>
  );
};

export default StoreProvider;
